import { Phone, Mail } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL_URL } from "@/lib/contact";

export const Logo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="1" y="1" width="30" height="30" fill="#ff6a13" />
    <path d="M6 22 h20 M6 22 v-6 h20 v6 M10 16 v-4 h12 v4" stroke="#111317" strokeWidth="2.5" fill="none" />
    <circle cx="10" cy="26" r="2" fill="#111317" />
    <circle cx="22" cy="26" r="2" fill="#111317" />
  </svg>
);

export const Header = () => (
  <header className="sticky top-0 z-40 bg-ground text-ink border-b-2 border-ink">
    <nav className="px-6 py-4 flex flex-wrap items-center justify-between gap-4">
      <a href="#top" data-testid="header-logo" className="mo flex items-center gap-2 text-sm">
        <Logo />
        <span>rosszkanape-elszallitas.hu</span>
      </a>
      <div className="flex flex-wrap gap-2 mo text-sm">
        <a data-testid="header-email-link" href={EMAIL_URL}
          className="btn-press hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-transport text-white">
          <Mail className="w-4 h-4" aria-hidden="true" /> E-mail
        </a>
        <a data-testid="header-call-button" href={PHONE_TEL}
          className="btn-press hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-ink text-white">
          <Phone className="w-4 h-4" aria-hidden="true" /> 24/7 · {PHONE_DISPLAY}
        </a>
      </div>
    </nav>
  </header>
);
